/* sucrase/dist/esm/transformers/OptionalCatchBindingTransformer.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    const tslib_1 = require("tslib");
    const types_1 = require("f0c35cbd76") /* ../parser/tokenizer/types */;
    const Transformer_1 = tslib_1.__importDefault(require("a46f119f74") /* ./Transformer */);
    class OptionalCatchBindingTransformer extends Transformer_1.default {
        constructor(tokens, nameManager) {
            super();
            this.tokens = tokens;
            this.nameManager = nameManager;
            ;
        }
        process() {
            if (this.tokens.matches2(types_1.TokenType._catch, types_1.TokenType.braceL)) {
                this.tokens.copyToken();
                this.tokens.appendCode(` (${this.nameManager.claimFreeName("e")})`);
                return true;
            }
            return false;
        }
    }
    exports.default = OptionalCatchBindingTransformer;
}
